import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { LayoutModule } from "../../../theme/layouts/layout.module";
import { SharedModule } from "../../../freightconfirmation/app.sharemodule";
import { DocumentsharedModule } from "../../../documentshared/documentshared.module";
import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
import { SharedComponentModule } from "../../../shared/shared.module";
import { TabViewModule } from "primeng/tabview";
import { NewDesignLayoutComponent } from "./new-design-layout.component";


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LayoutModule,
    SharedModule,
    RouterModule,
    DocumentsharedModule,
    SharedComponentModule,
    HttpClientModule,
    TabViewModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [NewDesignLayoutComponent],
  exports: [NewDesignLayoutComponent],
  providers: [TranslateConfigService],
})
export class NewDesginLayoutSharedModule { }
